import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Suggestion } from '@model/admin/suggestion';
import { Paginate } from '@model/admin/paginate';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class SuggestionService {

  constructor(private http: HttpClient) { }

  get(per_page: number = 10, page: number = 1, by_user:boolean): Observable<Paginate<Suggestion>> {
    return this.http.get<Paginate<Suggestion>>(`${environment.base_url}/suggestion?page=${page}&per_page=${per_page}&by_user=${by_user}`);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${environment.base_url}/suggestion/${id}`);
  }

  saveAnswer(data){
    return this.http.post(`${environment.base_url}/suggestion/save_answer`, data);
  }

  update(id: number, form:any): Observable<any> {
    return this.http.put(`${environment.base_url}/suggestion/${id}`, form);
  }
}
